import React, { useCallback } from 'react';
import { Box } from '@material-ui/core';
import { ModalDialog } from 'shared/components/modals/ModalDialog';
import { useDispatch, useSelector } from 'react-redux';
import { useColoredFormModalStyles } from 'shared/components/modals/ModalStyles';
import { AssignmentsMetaDataForm } from 'modules/settings/submodules/clients/assignmentsReportData/components/AssignmentsMetaDataForm/AssignmentsMetaDataForm';
import { IAssignmentsMetaDataFormValue } from 'modules/settings/submodules/clients/assignmentsReportData/components/AssignmentsMetaDataForm/model';
import { createAssignmentReportMetaDataAction, setOpenAssignmentMetaDataCreateModal } from 'modules/settings/submodules/clients/assignmentsReportData/store/actions';
import { selectIsCreatingAssignmentMeta, selectIsOpenedCreateAssignmentMetaModal } from 'modules/settings/submodules/clients/assignmentsReportData/components/CreateAssignmentReportMetaData/store/selectors';

export const CreateAssignmentReportMetaDataModal = () => {
    const classes = useColoredFormModalStyles();
    const dispatch = useDispatch();
    const isOpen = useSelector(selectIsOpenedCreateAssignmentMetaModal);
    const isLoading = useSelector(selectIsCreatingAssignmentMeta);

    const onClose = useCallback(() => {
        dispatch(setOpenAssignmentMetaDataCreateModal(false));
    }, [dispatch]);
    const onSave = useCallback((values: IAssignmentsMetaDataFormValue) => {
        dispatch(createAssignmentReportMetaDataAction.init({
            user_id: values.userId || '',
            uw_number: values.uwNumber.toString(),
            sso_id: values.ssoId.toString(),
        }));
    }, [dispatch]);

    return (
        <ModalDialog
            title="Create Assignment Metadata"
            isOpened={isOpen}
            onClose={onClose}
            modalProps={{
                customClasses: classes,
                showCloseIcon: true,
            }}
        >
            <Box>
                <AssignmentsMetaDataForm
                    onSubmit={onSave}
                    isLoading={isLoading}
                    selectUser
                />
            </Box>
        </ModalDialog>
    );
};
